import { FileInput, FileInputProps } from "@mantine/core";
import React, { useRef } from "react";
import { IFocusableFormField } from "@type";

export interface IFormFileInputProps<
  Values = Record<string, unknown>,
  Multiple extends boolean = false,
> extends FileInputProps<Multiple>,
    IFocusableFormField<Values> {}

export const FormFileInput: <
  Values = Record<string, unknown>,
  Multiple extends boolean = false,
>(
  props: IFormFileInputProps<Values, Multiple>,
) => JSX.Element = ({ fieldName, parentForm, ...rest }) => {
  const elementRef = useRef<HTMLButtonElement>(null);
  parentForm.registerField(fieldName, elementRef);
  return (
    <FileInput
      {...parentForm.getInputProps(fieldName)}
      {...rest}
      ref={elementRef}
    />
  );
};
